import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LanguagesFetchAPI } from '../../../api/Languages'
import LoadingAlert from '../../Alerts/LoadingAlert';
import { changeLanguage as setAppLanguage } from '../../../i18n';



function ModalLanguage() {
    const { t } = useTranslation();
    const [showModalLanguage, setShowModalLanguage] = useState(false);
    const [languages, setLanguages] = useState([])
    let token = undefined


    //get languages
    const getLanguages = async () => {
        try {
            const response = await LanguagesFetchAPI.getLanguages(token);
            setLanguages(response.data.languages)
        } catch (err) {
            //console.log(err);
        }
    }

    //change Language: usa i18next (static texts) + persiste en localStorage (usado tambien por el
    //interceptor de axios para pedir los datos dinamicos -productos/categorias/segmentos/promociones- traducidos)
    const setLanguage = (language) => {
        LoadingAlert(t('language.changing'), t('language.changingSubtitle'));
        setAppLanguage(language);
        setShowModalLanguage(false);

        //Recargamos para que las vistas que ya habian cargado datos del backend
        //(productos, categorias, segmentos, promociones) los vuelvan a pedir en el nuevo idioma
        setTimeout(() => {
            window.location.reload();
        }, 1200);
    }

    {/*view languages*/ }
    const viewLanguages = () => {

        const listItems = languages.map((language) => (
            <div className='m-3' key={language.code}>
                <div className='btn btn-outline-primary  d-block border border-3 rounded-pill p-3 ' onClick={() => setLanguage(language.code)}>
                    <span className='p-3  text-wrap px-3'>{language.name}</span>
                </div>
            </div>
        ));
        return (listItems)
    }

    useEffect(() => {
        getLanguages()
    }, []);
    return (
        <>

            <small class="d-flex gap-1 align-items-center text-white small" onClick={() => (setShowModalLanguage(true))} role='button'>
                <i class="uil uil-english-to-chinese  text-white"></i> {t('language.label')}
            </small>

            <Modal
                centered
                className='modal-dialog-kk '
                size="lg"
                show={showModalLanguage}
                onHide={() => setShowModalLanguage(false)}>
                <Modal.Body  className='bg-theme border-dark border rounded-2' >

                    <section className=' rounded-4 bg-theme' >

                        <div className=' scale-up-top mt-5'>
                            <h2 className=' text-center text-theme'>
                                <i className="uil uil-english-to-chinese ms-1 "></i>  {t('language.modalTitle')}
                            </h2>

                            {viewLanguages()}

                        </div>
                        <div className='text-muted text-center'>
                            <i className="uil uil-info-circle me-2"></i>
                            {t('language.modalSubtitle')}
                        </div>
                    </section>

                    <div className='d-flex justify-content-center m-2'>
                        <Button
                            onClick={() => (setShowModalLanguage(false))}
                            type="button"
                            variant="danger"
                        ><i class="uil uil-times-circle"></i> {t('common.close')}
                        </Button>
                    </div>
                </Modal.Body>



            </Modal>
        </>
    )
}

export default ModalLanguage
